/* ==========================================================================
   ACL · Filter-Drawer: nahtlos offen halten + Farbfamilien
   --------------------------------------------------------------------------
   Laeuft NUR, wenn #CollectionSidebar die Klasse .acl-filters traegt.

   1) Das Basis-Theme baut nach jedem Filterklick #CollectionAjaxContent neu auf
      — und der Drawer steckt mit drin. Das neu gelieferte Markup ist immer
      geschlossen, ein Wiederaufmachen allein wuerde also flackern. Darum setzen
      wir fuer die Dauer des Reloads die Klasse .acl-filtering auf <html>; die CSS
      haelt den Drawer und das Overlay in dieser Zeit sichtbar. Erst wenn die
      neue Instanz wirklich offen ist, faellt die Klasse wieder weg. Ergebnis:
      kein Auf- und Zuspringen, auch nicht auf dem Handy.

   2) Eine Farbfamilien-Pille steht fuer mehrere echte Filterwerte. Der Klick
      setzt alle versteckten Checkboxen der Familie und feuert EIN 'input'-Event,
      das zum Formular blubbert — genau das Event, auf das theme.Collection
      lauscht. Serialisiert wird danach das komplette Formular.
   ========================================================================== */
(function () {
  if (window.__aclFiltersInit) return;
  window.__aclFiltersInit = true;

  var FILTERING = 'acl-filtering';
  var reopen = false;
  var failsafe = null;

  function isAclCollection() {
    return !!document.querySelector('#CollectionSidebar.acl-filters');
  }

  function drawerIsOpen() {
    var d = document.querySelector('#FilterDrawer');
    return !!(d && d.classList.contains('drawer--is-open'));
  }

  function stopHolding() {
    document.documentElement.classList.remove(FILTERING);
    if (failsafe) {
      window.clearTimeout(failsafe);
      failsafe = null;
    }
  }

  function startHolding() {
    document.documentElement.classList.add(FILTERING);
    reopen = true;
    // Notbremse: falls collection:reloaded nie kommt, nicht dauerhaft klemmen.
    if (failsafe) window.clearTimeout(failsafe);
    failsafe = window.setTimeout(stopHolding, 6000);
  }

  // --- Klick auf irgendeine Pille im offenen Drawer (Capture, vor allem anderen)
  document.addEventListener(
    'click',
    function (evt) {
      if (!isAclCollection()) return;
      var t = evt.target;
      if (!t || !t.closest) return;
      if (!t.closest('#FilterDrawer .tag__checkbox-wrapper')) return;
      if (!drawerIsOpen()) return;
      startHolding();
    },
    true
  );

  document.addEventListener('collection:reloaded', function () {
    if (!reopen || !isAclCollection()) {
      stopHolding();
      return;
    }
    reopen = false;
    if (window.theme && theme.FilterDrawer && !theme.FilterDrawer.isOpen) {
      theme.FilterDrawer.open();
    }
    // Erst nach zwei Frames loslassen, dann hat der echte Offen-Zustand gegriffen.
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(stopHolding);
    });
  });

  // --- Familien-Pille schaltet alle Werte der Familie
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.acl-family__btn');
    if (!btn) return;

    evt.preventDefault();

    var li = btn.closest('li');
    if (!li) return;
    var boxes = li.querySelectorAll('.acl-family__inputs input.tag__input');
    if (!boxes.length) return;

    var turnOn = !li.classList.contains('tag--active');
    for (var i = 0; i < boxes.length; i++) {
      boxes[i].checked = turnOn;
    }
    btn.setAttribute('aria-pressed', turnOn ? 'true' : 'false');

    boxes[0].dispatchEvent(new Event('input', { bubbles: true }));
  });
})();